import React from 'react';

import Header from '../components/Header';
import Calculator from '../components/Calculator';
import Footer from '../components/Footer';

import '../styles/scss/view/calculator-container.scss';

const CalculatorContainer = () => {
  return (
    <div className="calculator-container">
      <Header />
      <Calculator />
      <Footer />
    </div>
  );
};

export default CalculatorContainer;
